import { useParams } from 'react-router-dom'

import { useDataCatalogSelector } from 'modules/ai_reports/components/DataCatalogSelector/useDataCatalogSelector'
// Required import for CI compliance :/
import CollectionsBootstrap from 'modules/ai_reports/lib/CollectionsBootstrap'
import { useSlugToSourceId } from 'modules/ai_reports/lib/useSlugToSourceId'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { AiReportsMainContent } from './components/ReportCreatePage'

typeof (<CollectionsBootstrap />)
// End

const AiReportsPage = () => {
  const { slug } = useParams()

  const { sourceId, loading: loadingSourceId, error: errorSourceId } = useSlugToSourceId(slug)

  const {
    datasources,
    loading: loadingDatasources,
    error: errorDatasources,
  } = useDataCatalogSelector()

  return (
    <>
      {loadingSourceId || errorSourceId || !sourceId || loadingDatasources || errorDatasources ? (
        <ResponsivePage.Body
          variant="fullscreen"
          loading={loadingSourceId || loadingDatasources}
          error={errorSourceId || errorDatasources}
        >
          &nbsp;
        </ResponsivePage.Body>
      ) : (
        <AiReportsMainContent
          sourceId={sourceId}
          datasource={datasources?.find((source) => source.id === sourceId)}
        />
      )}
    </>
  )
}

export default AiReportsPage
